import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash/isEqual';
import translationsForUsersLocale from './translations';
import { RootState } from 'redux/rootReducer';

const getLocale = (state: RootState) => state.settings.locale;

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

// eslint-disable-next-line
export const getMessagesState = createDeepEqualSelector([getLocale], (locale) => ({
  ...translationsForUsersLocale['en'],
  ...translationsForUsersLocale[locale]
}));
